// Game-module shim (unify Phase 3): resolves to the active game's RecordViewer.
// Conditional require so only the active game's module tree is evaluated.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/components/RecordViewer')
  : require('../games/dota/components/RecordViewer');
export default impl.default;
